/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateDateTime } from './createDateTime';
import { ExternalKey } from './externalKey';
import { ExternalKeys } from './externalKeys';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { UpdateDateTime } from './updateDateTime';

export interface PriceChangesHeadersListWithUserView { 
    /**
     * The unique identifier of this record.
     */
    priceChangesHeaderId?: number;
    organisationId?: string;
    /**
     * A way of identifying a set of changes
     */
    name?: string;
    /**
     * Identifies if set of price changes have been published
     */
    published?: boolean;
    /**
     * Identifies whether prices changes are scheduled or immediate.
     */
    scheduled?: boolean;
    /**
     * The date price changes take effect from.
     */
    scheduledDateFrom?: Date;
    /**
     * The date price changes take effect to.
     */
    scheduledDateTo?: Date;
    /**
     * The date price changes was published.
     */
    publishedDate?: Date;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    lastUpdateByUserId?: LastUpdateByUserId;
    externalKeys?: ExternalKeys;
    externalKey?: ExternalKey;
}